import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const EditLayoutContext = createContext();

export const EditLayoutProvider = (props) => {
  const [editing, setEditing] = useState();
  const [editingVisible, setEditingVisible] = useState();
  const value = useMemo(
    () => ({ editing, setEditing, editingVisible, setEditingVisible }),
    [editing, editingVisible]
  );

  return <EditLayoutContext.Provider value={value} {...props} />;
};

export const useEditLayout = () => useContext(EditLayoutContext);
export const useEditLayoutVisible = () => {
  const { setEditingVisible } = useEditLayout();

  useEffect(() => {
    setEditingVisible(true);
    return () => setEditingVisible(false);
  }, [setEditingVisible]);
};
